import React from 'react'
import ChevronIcon from './ChevronIcon'

import { ReactComponent as GlassesIcon } from 'assets/svg/glasses.svg'
import { ReactComponent as SunglassesIcon } from 'assets/svg/sunglasses.svg'
import { ReactComponent as LensIcon } from 'assets/svg/lens.svg'

import { Border, Color, Gap, Product, Size } from 'const'
import styled from 'styled-components'
import ProductBox from './ProductBox'
import { useHistory } from 'react-router-dom'
import queryString from 'query-string'
import { useQuery } from 'react-query'
import purchasesAPI from 'utils/axios/modules/purchases'
import { getDispDate } from 'utils/datetime'
import _ from 'lodash'

const Receipt = ({ receipt }) => {
  const history = useHistory()

  const { sales_id: salesId } = receipt

  const { isLoading, data: response } = useQuery({
    queryKey: ['getDetails', salesId],
    queryFn: () => purchasesAPI.getDetails({ salesId }),
    enabled: !!salesId,
  })

  const receiptDetail = response?.data || { info: {}, items: {} }

  const { items } = receiptDetail

  const displayDate = `購入日：${receipt.sales_date ? getDispDate(receipt.sales_date) : '-'}`

  const ORDERS = {
    frame: 1,
    sungalsses: 1,
    lens_r: 2,
    lens_l: 3,
    contact_lens_r: 2,
    contact_lens_l: 3,
  }

  const receiptItems = _.entries(items)
    .map((group) => ({
      product_type: group[0],
      position: ORDERS[group[0]],
      ...group[1],
    }))
    .sort((a, b) => a.position - b.position)

  const navigateReceiptDetail = () => {
    const queryParams = queryString.stringify({
      sales_id: receipt.sales_id,
      box_id: receipt.box_id || '',
    })
    history.push(`/purchases/details?${queryParams}`)
  }

  const totalItems = receiptItems.length

  const moreItemText = totalItems > 3 ? `他${receiptItems.slice(3).length}点` : ''

  const displayItems = totalItems > 3 ? receiptItems.slice(0, 3) : receiptItems

  const Footer = !isLoading && moreItemText && <ReceiptInfo>{moreItemText}</ReceiptInfo>

  const renderReceiptItems =
    receiptItems.length > 0 ? (
      <ReceiptSummary>
        {displayItems.map((item, index) => (
          <ProductBoxWrapper key={index} productType={item.product_type} brand={item.brand} name={item.name} />
        ))}
      </ReceiptSummary>
    ) : isLoading ? (
      <p>Loading...</p>
    ) : null

  return (
    <ReceiptBox role="button" tabIndex={0} onClick={navigateReceiptDetail}>
      <ReceiptHeader>
        <ReceiptTitle>{displayDate}</ReceiptTitle>
        <ReceiptNavigation>
          <ChevronIcon />
        </ReceiptNavigation>
      </ReceiptHeader>
      <ReceiptBody>{renderReceiptItems}</ReceiptBody>
      {Footer}
    </ReceiptBox>
  )
}

const ReceiptBox = styled.div`
  background: ${Color.BACKGROUND.BASE};
  border: 1px solid ${Color.BORDER.MENU};
  border-radius: ${Border.MENU.RADIUS};
  padding: 10px 20px 30px;
  display: flex;
  flex-direction: column;
  gap: ${Gap.XL};
  text-decoration: none;
  cursor: pointer;
  position: relative;
`

const ReceiptHeader = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${Color.BORDER.MENU};
  gap: ${Gap.LG};
  padding: 16px 0;
`

const ReceiptTitle = styled.div`
  flex: 1;
  font-size: ${Size.FONT.LG};
  font-weight: bold;
`

const ReceiptNavigation = styled.div``

const ReceiptBody = styled.div`
  display: flex;
  flex-direction: column;
`

const ReceiptSummary = styled.div`
  display: grid;
  gap: ${Gap.MD};
  grid-template-columns: 1fr;
  padding-bottom: ${Gap.XXL};
`

const ReceiptInfo = styled.div`
  display: table;
  font-size: 14px;
  position: absolute;
  bottom: 16px;
`

export const ProductBoxWrapper = ({ productType, brand, name }) => {
  switch (productType) {
    case Product.TYPES.FRAME:
      return <ProductBox svg={<GlassesIcon />} info="フレーム" text={`${brand} ${name}`} />
    case Product.TYPES.SUNGALSSES:
      return <ProductBox svg={<SunglassesIcon />} info="サングラス" text={`${brand} ${name}`} />
    case Product.TYPES.LENS_L:
      return <ProductBox svg={<LensIcon />} info="レンズL" text={`${brand} ${name}`} />
    case Product.TYPES.LENS_R:
      return <ProductBox svg={<LensIcon />} info="レンズR" text={`${brand} ${name}`} />
    case Product.TYPES.CONTACT_LENS_L:
      return <ProductBox svg={<LensIcon />} info="コンタクトレンズL" text={`${brand} ${name}`} />
    case Product.TYPES.CONTACT_LENS_R:
      return <ProductBox svg={<LensIcon />} info="コンタクトレンズR" text={`${brand} ${name}`} />
    default:
      return <></>
  }
}

export default Receipt
